'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('./../../../external/classnames/index.js');
var PropTypes = require('prop-types');
var Card = require('../../../composites/Card/Card.js');
var CardBody = require('../../../composites/Card/CardBody/CardBody.js');
require('../../../composites/Card/CardImage/CardImage.js');
require('../../../composites/Card/CardText/CardText.js');
require('../../../composites/Card/CardTitle/CardTitle.js');
require('../../../composites/Carousel/Carousel.js');
require('../../../composites/Carousel/CarouselControl/CarouselControl.js');
require('../../../composites/Carousel/CarouselIndicator/CarouselIndicator.js');
require('../../../composites/Carousel/CarouselIndicators/CarouselIndicators.js');
require('../../../composites/Carousel/CarouselItem/CarouselItem.js');
require('../../../composites/Carousel/CarouselInner/CarouselInner.js');
require('../../../composites/EventCard/EventCard.js');
require('../../../composites/EventCard/EventGrid/EventGrid.js');
require('../../../composites/Modal/Modal.js');
require('../../../composites/Modal/ModalBody/ModalBody.js');
require('../../../composites/Modal/ModalFooter/ModalFooter.js');
require('../../../composites/Modal/ModalHeader/ModalHeader.js');
require('../../../composites/SearchBar/SearchBar.js');
require('../../../composites/Video/Video.js');
var play_triangle_inline = require('../../../assets/svg/play_triangle.inline.svg.js');
var index$1 = require('../../../utilities/GatsbyLink/index.js');
require('../../../primitives/Hero/Hero.js');
require('../../../primitives/HeroSrcSet/HeroSrcSet.js');
var Icon = require('../../../primitives/Icon/Icon.js');
require('../../../primitives/Link/Link.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefault(React);
var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var PodcastCard = function PodcastCard(props) {
  var className = props.className,
    date = props.date,
    title = props.title,
    season = props.season,
    episode = props.episode,
    podcastName = props.podcastName,
    description = props.description,
    link = props.link,
    background = props.background,
    target = props.target,
    width = props.width;
  var classes = index.default('lanl-podcast-card m-0', className);
  return /*#__PURE__*/React__default.default.createElement(Card.Card, {
    className: classes,
    style: {
      width: width,
      background: background
    }
  }, /*#__PURE__*/React__default.default.createElement(CardBody.CardBody, null, /*#__PURE__*/React__default.default.createElement("div", {
    className: "lanl-podcast-date"
  }, date), /*#__PURE__*/React__default.default.createElement("h3", {
    className: "lanl-podcast-title"
  }, title), /*#__PURE__*/React__default.default.createElement("div", {
    className: "lanl-podcast-info"
  }, /*#__PURE__*/React__default.default.createElement("h4", {
    className: "lanl-podcast-name"
  }, podcastName, " | ", season, " : ", episode), /*#__PURE__*/React__default.default.createElement("p", {
    className: "lanl-podcast-desc"
  }, description)), /*#__PURE__*/React__default.default.createElement(index$1.default, {
    href: link,
    target: target,
    className: "lanl-podcast-link"
  }, /*#__PURE__*/React__default.default.createElement("span", {
    className: "fa-stack fa-2x"
  }, /*#__PURE__*/React__default.default.createElement(Icon.Icon, {
    icon: "circle",
    className: "fa-stack-2x lanl-podcast-icon-bg"
  }), /*#__PURE__*/React__default.default.createElement(play_triangle_inline.default, {
    className: "fa-stack-1x lanl-podcast-play"
  })), "Listen Now ", /*#__PURE__*/React__default.default.createElement("span", {
    className: "sr-only"
  }, "to the podcast: ", title))));
};
PodcastCard.propTypes = {
  date: PropTypes__default.default.string.isRequired,
  description: PropTypes__default.default.string.isRequired,
  episode: PropTypes__default.default.string.isRequired,
  link: PropTypes__default.default.string.isRequired,
  podcastName: PropTypes__default.default.string.isRequired,
  season: PropTypes__default.default.string.isRequired,
  title: PropTypes__default.default.string.isRequired,
  background: PropTypes__default.default.string,
  className: PropTypes__default.default.string,
  target: PropTypes__default.default.oneOf(['_blank', '_self', '_parent', '_top', '']),
  width: PropTypes__default.default.string
};
PodcastCard.defaultProps = {
  background: 'transparent',
  target: ''
};

exports.PodcastCard = PodcastCard;
exports.default = PodcastCard;
//# sourceMappingURL=PodcastCard.js.map
